export default {
  messageType: 'Wide Item List',
  itemListSetting: 'Item Settings',
  title: 'Wide Item List Settings',
  label: {
    mainTitle: 'Title',
    content: [
      'Content',
      'Content',
      'Content',
      'Content',
    ],
    image: [
      'Attach Image',
      'Attach Image',
      'Attach Image',
      'Attach Image',
    ],
    imageDescription: [
      'Recommended: 800x400 (2:1) / Max 5MB',
      'Recommended: 800x800 (1:1) / Max 5MB',
      'Recommended: 800x800 (1:1) / Max 5MB',
      'Recommended: 800x800 (1:1) / Max 5MB',
    ],
    mobileLink: [
      'Mobile Web Links',
      'Mobile Web Links',
      'Mobile Web Links',
      'Mobile Web Links',
    ],
    pcLink: [
      'PC Web links',
      'PC Web Links',
      'PC Web Links',
      'PC Web Links',
    ],
    iosDeepLink: [
      'iOS App Link',
      'iOS App Link',
      'iOS App Link',
      'iOS App Link',
    ],
    androidDeepLink: [
      'App Link',
      'App Link',
      'App Link',
      'App Link',
    ],
  },
  alt: {
    image: 'Wide Item List Image',
  },
  validation: {
    list: { max: 'You can set up to four wide-item list-type items.' },
  },
};
